<div class="addNewPolicyContainer">

  <div class="Loading" *ngIf="isShowLoading">
    <div class="loader"></div>
    <label class="loaderlabel">Please wait while Processing....</label>
  </div>

  <div class="Clears"></div>
</div>


<div class="container-fluid">
  <div class="MyProposalForm disForm seoLandingPage">
    <div class="col-lg-5 col-md-5 hidden-sm hidden-xs">
      <div class="car_bg">

        <div class="Description">
          <img src="assets/theme/en/images/1.png">
          <h3>{{'Travel Insurance'|translate}}</h3>
          <!-- <h3>{{'Travel Insurance'| translate }}</h3> -->
          <!-- <span>Template data need to provide by ACIG</span>
                    
                                        <ul>
                                            <li>XXX XXXXXXXXX XXXXXXX XXXXXXX</li>
                                            <li>XXXXX XXXXXXXXXX XXXXXXX XXXXXX</li>
                                            <li>XX XXXXXX XXXXXXXX XXXXXXX XXXXXXXX</li>
                                            <li>XXX XXX XXXX XXXXXX XXXXX XXXX</li>
                      
                    </ul> -->
        </div>
        <i class="fa fa-angle-right arrows"></i>
      </div>
    </div>
    <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
      <form #TravelPolicyConfirm="ngForm">
        <div class="CarForm">
          <div class="InsuredInformation Infomation">

            <div class="FormSection">

              <div class="Clears"></div>


              <!---ONE-->

              <div class="panel panel-default panel-table">
                <div class="panel-heading">
                  <div class="row">
                    <div class="col col-xs-12">
                      <h3 class="panel-title"><b>{{'Travel Premium Info in SAR'|translate}}</b></h3>
                    </div>
                    <div class="col col-xs-6 text-right">

                    </div>
                  </div>
                </div>
                <div class="panel-body">
                  <table class="table table-striped table-bordered table-list">

                    <tbody>
                      <tr>
                        <td></td>
                        <td class="text-right">{{'Gross Premium'|translate}}</td>
                        <td class="text-value">{{travelBindObj.propoalObj.GrossPremium | number : '1.2-2' }}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="text-right">{{'CrossSell Discount'|translate}}</td>
                        <td class="text-value">{{travelBindObj.propoalObj.CrossSellDiscountAmt | number : '1.2-2' }}
                          ({{travelBindObj.propoalObj.CrossSellDiscountPer}}%)
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="text-right">{{'User Discount'|translate}}</td>
                        <td class="text-value">{{travelBindObj.propoalObj.UserDiscountAmt | number : '1.2-2' }}
                          ({{travelBindObj.propoalObj.UserDiscountPer}}%)
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="text-right">{{'PromoDiscount'|translate}}</td>
                        <td class="text-value">{{travelBindObj.propoalObj.PromoDiscount | number : '1.2-2'}}({{travelBindObj.propoalObj.PromoDiscountPer}}%)</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="text-right">{{'Total Premium(Excluding VAT)'|translate}}</td>
                        <td class="text-value">{{ travelBindObj.propoalObj.VATBeforePremium | number : '1.2-2' }}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="text-right">{{'VAT Amount'|translate}}</td>
                        <td class="text-value">{{ travelBindObj.propoalObj.VATAmount | number : '1.2-2' }}({{travelBindObj.propoalObj.VATPercent}}%)</td>
                      </tr>

                      <tr>
                        <td></td>
                        <td class="text-right">{{'UPR VAT Amount'|translate}}</td>
                        <td class="text-value">{{ travelBindObj.propoalObj.UPRVAT | number : '1.2-2' }}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="text-right">{{'Total Premium'|translate}}</td>
                        <td class="text-value" style="color:red;font-weight:bold">{{ travelBindObj.propoalObj.TotalPremium | number : '1.2-2' }}
                          &nbsp; &nbsp;&nbsp;&nbsp;
                        </td>
                      </tr>
                      <!-- <tr>
                                                                <td colspan="2">
                                                                </td>
                                                                <td>
                                                                        <label (click)="showmore()" style="color:maroon;font-weight:bold">{{BtnText}}</label>
                                                                </td>
                                                            </tr>  -->

                    </tbody>

                  </table>


                  <div *ngIf="isMore==true">
                    <table class="table table-striped table-bordered table-list" ng-show="isMore==true">
                      <tbody>
                        <tr>
                          <td class="text-right">{{'Insured Premium'|translate}}</td>
                          <td class="text-value" style="color:black;font-weight:bold" colspan="3">{{ travelBindObj.propoalObj.InsuredPremium | number : '1.2-2' }}</td>
                        </tr>
                        <tr>
                          <td class="text-right">{{'Adults Premium'|translate}}</td>
                          <td class="text-value" style="color:black;font-weight:bold">{{ travelBindObj.propoalObj.FamilyPremium | number : '1.2-2' }}</td>

                          <td class="text-right">{{'No of Adults'|translate}}</td>
                          <td class="text-value" style="color:blackred;font-weight:bold">{{ travelBindObj.propoalObj.NoOfAdults | number }}</td>
                        </tr>
                        <tr>
                          <td class="text-right">{{'Children Premium'|translate}}</td>
                          <td class="text-value" style="color:blackred;font-weight:bold">{{ travelBindObj.propoalObj.ChildsPremium | number : '1.2-2' }}</td>

                          <td class="text-right">{{'No of Childrens'|translate}}</td>
                          <td class="text-value" style="color:black;font-weight:bold">{{ travelBindObj.propoalObj.NoOfChilds | number }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>


                  <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-6 text-right">{{'Promo Code'|translate}}</div>
                    <div class="col-md-4 col-sm-4 col-xs-6"><input type="text" class="form-control col-md-4" id="promoid" name="promoid" [(ngModel)]="travelBindObj.propoalObj.PromoCode" [disabled]="IsPromoApplied==true" /></div>
                    <div class="col-md-4 col-sm-4 col-xs-6"><button class="btn btn-primary" style="float:right;" id="btnApply" name="btnApply" (click)="ApplyPromo()" [disabled]="IsPromoApplied==true || (travelBindObj.propoalObj.PromoCode==null ||travelBindObj.propoalObj.PromoCode=='') ">{{'Apply'|translate}}</button></div>
                  </div>


                </div>
              </div>

              <!-----TWO---->


              <div *ngIf="false">
                <div class="Field">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <label class="lbltext">{{'Gross Premium'| translate }}</label>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                      <input type="text" id="txtGross" name="txtGross" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.GrossPremium" #txtGross="ngModel">


                    </div>
                  </div>
                </div>


                <div class="Field" *ngIf="travelBindObj.propoalObj.CrossSellDiscountExists">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <label class="lbltext">{{'CrossSell Discount'| translate }}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <input type="text" id="txtCrossSell" name="txtCrossSell" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.CrossSellDiscountAmt" #txtCrossSell="ngModel">

                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12">
                      <label> %</label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <input type="text" id="txtCrossSellPer" name="txtCrossSellPer" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.CrossSellDiscountPer" #txtCrossSellPer="ngModel">

                    </div>
                  </div>
                </div>

                <div class="Field" *ngIf="travelBindObj.propoalObj.PromoDiscountExists">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <label class="lbltext">{{'Promo Disount'| translate }}</label>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                      <input type="text" id="txtPromoDiscount" name="txtPromoDiscount" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.PromoDiscount" #txtPromoDiscount="ngModel">

                    </div>
                  </div>
                </div>
                <div class="Field">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <label class="lbltext">{{'Total Premium (Excluding VAT)'| translate }}</label>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                      <input type="text" id="txtBeforeVAT" name="txtBeforeVAT" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.VATBeforePremium" #txtBeforeVAT="ngModel">

                    </div>
                  </div>
                </div>
                <div class="Field">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <label class="lbltext">{{'VAT AMOUNT'| translate }}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <input type="text" id="txtVAT" name="txtVAT" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.VATAmount" #txtVAT="ngModel">


                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12">
                      <label class="lbltext">%</label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <input type="text" id="txtVATPer" name="txtVATPer" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.VATPercent" #txtVAT="ngModel">


                    </div>
                  </div>
                </div>
                <div class="Field">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <label class="lbltext">{{'Total Premium(Including VAT)'| translate }}</label>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                      <input type="text" id="txtTotal" name="txtTotal" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.TotalPremium" #txtTotal="ngModel">


                    </div>
                  </div>
                </div>


              </div>
















            </div>






            <!-- Button Actions -->

            <div class="Actionsection">
              <div class="Actions">
                <div class="btn-group">

                  <button type="button" name="txtBUY" id="txtBUY" class="btn btn-primary btns" (click)="goNext()">{{'Proceed'| translate }}</button>

                </div>
              </div>
            </div>
            <div class="Clears"></div>

          </div>
        </div>
      </form>
    </div>


  </div>
</div>

<div class="PayMethods">
  <img src="assets/img/payment-footer-en1.png">
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelNewProposalConfirm/TravelNewProposalConfirm.html